module.exports = __webpack_public_path__ + "img/check_mark_accept_icon.a0455578.svg";